import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
/**
 * @hidden
 */
export var footerDisplayName = 'ActionSheetFooter';
/**
 * The KendoReact ActionSheetFooter component.
 */
export var ActionSheetFooter = function (props) {
    return (React.createElement("div", { className: classNames('k-actionsheet-footer', props.className) }, props.children));
};
ActionSheetFooter.propTypes = {
    className: PropTypes.string
};
/**
 * @hidden
 */
ActionSheetFooter.displayName = footerDisplayName;
/**
 * @hidden
 */
ActionSheetFooter.propTypes = {
    children: PropTypes.any
};
